import styled from 'styled-components';

const UploadSambaContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const ProgressBarContainer = styled.div`
  margin-top: 15px;
`;

const ContentUpload = styled.button`
  height: 100%;
  width: 100%;
  background: none;
  border: solid 1px var(--default-dark-gray);
  border-radius: 15px;
  cursor: pointer;
  color: var(--primary-color);

  &:hover {
    transition: all 0.3s;
    background: var(--primary-color);
    color: white;
  }

  p {
    font-size: var(--font-large);
    margin-bottom: 10px;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export {
  ContentUpload,
  UploadSambaContainer,
  ProgressBarContainer
}